<script>
import { mapGetters } from 'vuex';
import QuestionCard from '../components/QuestionCard';
import QuestionListHeader from '../components/QuestionListHeader';
import '../directives';

export default {
    name: 'QuestionsOverview',
    components: {
        QuestionCard,
        QuestionListHeader
    },
    computed: {
        ...mapGetters({
            questions: 'getAllQuestionsFiltered',
            isLoading: 'getQuestionsIsLoading',
            isSearchLoading: 'getSearchIsLoading',
        }),
    },
};
</script>

<template>
    <section class="questions-overview">
        <question-list-header v-if="!isLoading"></question-list-header>
        
        <transition-group name="card" class="questions-overview__list" mode="out-in">
            <question-card 
                v-for="(question) in questions" 
                v-bind:key="question.id" 
                v-bind:title="question.title.rendered" 
                v-bind:slug="question.slug" 
                v-bind:categories="question.question_categories">
            </question-card>
        </transition-group>

    </section>
</template>

<style lang="scss" scoped>
.questions-overview {
    @include container;
    @include page;
}
.questions-overview__list {
    @include row;
}
.question-card {
    @include col;
    width: calc(50% - 3.2rem);

    @include breakpoint("xs-down") {
        width: 100%;
    }
}
.card-enter-active {
    transition: opacity 750ms;
}
.card-leave-active {
    transition: opacity 500ms;
}
.card-enter {
    opacity: 0;
}
.card-leave-to {
    opacity: 0;
}
</style>
